import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "time"
};
const _hoisted_2 = {
    key: 1,
    class: "tag"
};
const _hoisted_3 = { class: "bottom-tags" };
const _hoisted_4 = {
    key: 0,
    class: "aut-tag",
    src: "/img/capital/autentic.svg"
};
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 2,
    class: "vote bottom-tag"
};
const _hoisted_7 = {
    key: 3,
    class: "type-tag bottom-tag"
};
const _hoisted_8 = ["src"];
import { checkAccess, scope } from "@/help/accessData";
import { computed } from "vue";
import { getIsAutenticProject, getSectionName, getStatus, projectTypeIcon, projectTypeName } from "@/components/capital/projectHelper";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectMainInfoIcons',
    props: {
        project: {}
    },
    setup(__props) {
        const store = useStore();
        const props = __props;
        const sectionCapital = computed(() => store.getters["sectionCapital"]);
        const isTester = computed(() => checkAccess(scope.testRole, store));
        const isAutenticProject = computed(() => getIsAutenticProject(props.project));
        const typeIcon = computed(() => projectTypeIcon(props.project));
        const typeName = computed(() => projectTypeName(props.project));
        const tag = computed(() => getSectionName(props.project.section, sectionCapital.value));
        const isVoting = computed(() => props.project.projectType === "voting");
        const statusData = computed(() => getStatus(props.project));
        const style = computed(() => ({
            "--status-color": statusData.value.statusColor
        }));
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: "top-tags",
                    style: _normalizeStyle(style.value)
                }, [
                    (statusData.value.status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(_component_UIcon, {
                                icon: statusData.value.statusIcon
                            }, null, 8, ["icon"]),
                            _createTextVNode(" " + _toDisplayString(statusData.value.status), 1)
                        ]))
                        : _createCommentVNode("", true),
                    (isTester.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(tag.value), 1))
                        : _createCommentVNode("", true)
                ], 4),
                _createElementVNode("div", _hoisted_3, [
                    (isAutenticProject.value)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5)),
                    (isVoting.value && isTester.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_UIcon, { icon: "vote" }),
                            _cache[0] || (_cache[0] = _createTextVNode(" Voting ", -1))
                        ]))
                        : (typeIcon.value && isTester.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("img", {
                                    src: `/img/capital/${typeIcon.value}.png`
                                }, null, 8, _hoisted_8),
                                _createTextVNode(" " + _toDisplayString(typeName.value), 1)
                            ]))
                            : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
